import { Breadcrumb, Skeleton, Row, Col, Select, Tree } from 'antd';
import { ButtonAction, Card, Form, FormItem, GetValidateFields, Input, Toggle, Button, Confirm } from 'asumsi-components';
import { LayoutCMS } from 'components';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useAction from '@pages/roles/hooks/useAction';
import { IResponseApplication } from '@interfaces/iresponse-application';
import { IResponseMenu, IResponsePrivilege } from '@interfaces/iresponse-menu';

export const PageRolesFormComponent = (props: any) => {
    const { Option } = Select;
    // set header page
    const title = 'Roles'
    const layoutCMSProps = {
        breadcrumb: (
            <>
                <Breadcrumb.Item>
                    {title}
                </Breadcrumb.Item>
            </>
        ),
        documentTitle: title,
        history: props.history,
        pageTitle: title,
    };

    // declare action and attribute needed
    const { isLoader, getDetail, postData, updateData, applications, getApplications, detail, getMenus, menus } = useAction();
    const { match } = props;
    const idData = match.params.id;

    // initiate form data
    const initialFieldsValues: any = {
        name: "",
        appCode: "",
        desc: "",
        access: []
    };

    const [fieldsValues, setFieldsValues]: any = useState(initialFieldsValues);
    const [selectedAccess, setSelectedAccess]: any[] = useState([]);
    const [showConfirmation, setShowConfirm] = useState(false);
    const [paramSubmit, setParamSubmit] = useState({});

    // first load
    useEffect(() => {
        fetchApplication();
        if (idData && !detail) {
            getDetail(idData);
        }
        if (idData && detail) {
            setDefault();
            fetchMenus(detail.appCode);
        }
    }, [detail])

    // fetch data
    const setDefault = async () => {
        if (detail) {
            setFieldsValues({
                name: detail.name,
                appCode: detail.appCode,
                desc: detail.desc,
                active: detail.active,
                access: detail.access.map((acs: any) => acs.id)
            });
            let setDefaultAccess: any = null;
            await detail.access.forEach((dt: any) => {
                const selected: string[] = detail.access.filter((ft: any) => ft.menuId == dt.menuId);
                const strValue = JSON.parse(`{"${dt.menuId}": []}`);
                const newValue = Object.assign(strValue);
                newValue[dt.menuId] = selected.map((ch: any) => ch.id);
                setDefaultAccess = { ...setDefaultAccess, ...newValue };
            })
            setSelectedAccess({ ...selectedAccess, ...setDefaultAccess });
        }
    }

    // fetch application
    const fetchApplication = async () => {
        getApplications({ page: 1, limit: 10, all: true });
    }

    //fetch menus 
    const fetchMenus = async (appCode: string) => {
        getMenus({ all: true, appCode });
    }

    // handle submit form
    const handleSubmit = (e: any) => {
        const validateFields = GetValidateFields(fieldsValues);
        const { err, values } = validateFields;
        e.preventDefault();
        if (!err) {
            const access: string[] = [];
            Object.keys(selectedAccess).forEach((key: any) => {
                access.push(...selectedAccess[key]);
            });
            let val: any = { ...values, access };
            val = { ...val, active: val.active ? true : false };
            setParamSubmit(val);
            setShowConfirm(true);
        }
    };

    // application options
    const optionsApp = applications ? applications.map((tp: IResponseApplication) => <Option key={tp.appCode} value={tp.appCode}>{tp.appName}</Option>) : null;
    const changeApp = (value: string) => {
        fetchMenus(value);
        setFieldsValues({ ...fieldsValues, appCode: value, errors: [] });
    }

    const getChild = (children: IResponsePrivilege[]) =>
        children.map((dt: IResponsePrivilege) => Object.assign({ title: dt.access, key: dt.id }))

    const finalMenus = menus.map((menu: IResponseMenu) => Object.assign({ title: menu.name, key: menu.id, children: getChild(menu.privileges) }))

    const onCheck = (menuId: string, checkedKeys: any) => {
        const selected: string[] = checkedKeys.filter((ft: string) => ft != menuId);
        const strValue = JSON.parse(`{"${menuId}": []}`);
        const newValue = Object.assign(strValue);
        newValue[menuId] = selected;
        setSelectedAccess({ ...selectedAccess, ...newValue });
    };

    const emptyImage = () =>
        <div className="empty-menus">
            Please Select application
        </div>;

    // return JSX Element 
    return (
        <LayoutCMS {...layoutCMSProps}>
            <Card className="asumsi-card-form-shadow-rd-15">
                <Form>
                    <Skeleton loading={isLoader}>
                        <Row gutter={30}>
                            <Col lg={{ span: 24 }} md={{ span: 24 }} xs={{ span: 32 }}>
                                <Row>
                                    <Col span={10}>
                                        <FormItem width="90%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Name" labelAlign="left"
                                            fieldDecorator={{
                                                label: "name",
                                                rules: [{
                                                    message: 'Please input name',
                                                    required: true,
                                                }
                                                ]
                                            }}
                                        >
                                            <Input id="name" defaultValue={fieldsValues.name} />
                                        </FormItem>
                                    </Col>
                                    <Col span={7}>
                                        <FormItem width="90%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Application" labelAlign="left"
                                            fieldDecorator={{
                                                label: "appCode",
                                                rules: [{
                                                    message: 'Please select application',
                                                    required: true,
                                                }
                                                ]
                                            }}
                                        >
                                            <Select
                                                id="appCode"
                                                showSearch
                                                style={{ width: "400px" }}
                                                onChange={changeApp}
                                                allowClear={false}
                                                optionFilterProp="children"
                                                value={fieldsValues.appCode}
                                                defaultValue={fieldsValues.appCode}
                                                placeholder="Please select application">
                                                {optionsApp}
                                            </Select>
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={17}>
                                        <FormItem width="96%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Description" labelAlign="left"
                                            fieldDecorator={{
                                                label: "desc"
                                            }}
                                        >
                                            <Input id="desc" defaultValue={fieldsValues.desc} />
                                        </FormItem>
                                    </Col>
                                    <Col span={7}>
                                        <FormItem width="50%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Active" labelAlign="left"
                                            fieldDecorator={{
                                                label: "active"
                                            }}
                                        >
                                            <Toggle id="active" defaultChecked={fieldsValues.active} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24}>
                                        <Card>
                                            <Row>
                                                {finalMenus && finalMenus.length > 0 ? finalMenus.map((menu: any) => <Col span={6}>
                                                    <Tree
                                                        checkable
                                                        defaultSelectedKeys={fieldsValues.access}
                                                        defaultCheckedKeys={fieldsValues.access}
                                                        defaultExpandAll={true}
                                                        treeData={menu}
                                                        onCheck={(checkedKeys: any) => {
                                                            onCheck(menu.key, checkedKeys);
                                                        }}
                                                    />
                                                </Col>) : <Col span={24}>{emptyImage()}</Col>}
                                            </Row>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Skeleton>
                    <ButtonAction
                        left={
                            <Link to="/user/roles">
                                <Button type="outline-red" size="medium" disabled={isLoader} text="Cancel"></Button>
                            </Link>
                        }
                        right={
                            <Button type="green" size="medium" disabled={fieldsValues.errors && fieldsValues.errors.length > 0} loading={isLoader} onClick={handleSubmit}>
                                Save
                            </Button>
                        }
                    />
                </Form>
            </Card>
            <Confirm
                key="confirm-save"
                show={showConfirmation}
                setShow={setShowConfirm}
                onOk={async () => {
                    if (!idData) {
                        // do post data
                        postData(paramSubmit);
                    } else {
                        // do update data
                        updateData(paramSubmit, idData);
                    }
                }}
                content='Apakah Anda yakin untuk menyimpan data ini?'
                title='Konfirmasi'
                okText='Ya'
                cancelText='Tidak'
            />
        </LayoutCMS>
    );
};
export default PageRolesFormComponent;



// WEBPACK FOOTER //
// ./src/pages/roles-form/component.tsx